import { Card, Col, Empty, Layout, Menu, Pagination, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import AIImageAnalysls from '../../assets/icons/AI_Image_Analysls.svg';
import AllServices from '../../assets/icons/All_Services.svg';
import Group569 from '../../assets/icons/Group_569.svg';
import ProIcon from '../../assets/icons/pro_service.svg';
import SafetyAndSercurity from '../../assets/icons/Safety_and_Sercurity.svg';
import SystemAlerts from '../../assets/icons/System_Alerts.svg';
import SystemIntegration from '../../assets/icons/System_Integration.svg';
import Spinner from '../../components/Spinner';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import ActivationComponent from './Activation';
import './index.scss';

const { Sider, Content } = Layout;

const ServicePage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { services, isAuth, namespace } = useSelector((state) => state);
  const [listService, setListService] = useState(services);
  const [listServiceTemp, setListServiceTemp] = useState(services);
  const [dataService, setDataService] = useState([]);
  const [detailService, setDetailService] = useState({
    visible: false,
    service: null,
  });
  const [key, setKey] = useState(Math.random());
  const [current, setCurrent] = useState(1);
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);
  const [count5, setCount5] = useState(0);
  const [type, setType] = useState(0);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_SERVICE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));

      let dataObjectRequestToken = {
        appServiceType: SERVICE.GENERATE_SHORT_TOKEN,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };

      dispatch(socketEmitEvent(dataObjectRequestToken));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (services) {
      const data = [...services];
      setListService(services);
      setListServiceTemp(services);
      setDataService(data?.sort(compare)?.slice(0, 12) || 0);

      let data1 = [];
      services.map((item) => {
        if (item?.category?.split(';')?.find((item1) => item1 === 'ai')) {
          data1 = [...data1, item];
        }
      });
      let data2 = [];
      services.map((item) => {
        if (
          item?.category?.split(';')?.find((item1) => item1 === 'intergation')
        ) {
          data2 = [...data2, item];
        }
      });
      let data3 = [];
      services.map((item) => {
        if (
          item?.category?.split(';')?.find((item1) => item1 === 'notification')
        ) {
          data3 = [...data3, item];
        }
      });
      let data4 = [];
      services.map((item) => {
        if (item?.category?.split(';')?.find((item1) => item1 === 'security')) {
          data4 = [...data4, item];
        }
      });
      let data5 = [];
      services.map((item) => {
        if (item?.category?.split(';')?.find((item1) => item1 === 'utility')) {
          data5 = [...data5, item];
        }
      });
      setCount1(data1?.length || 0);
      setCount2(data2?.length || 0);
      setCount3(data3?.length || 0);
      setCount4(data4?.length || 0);
      setCount5(data5?.length || 0);
    }
  }, [services]);

  const handleViewDetail = (service) => {
    return setDetailService({
      visible: false,
      service,
    });
  };

  const onShowSizeChange = (current, pageSize) => {
    const data = listServiceTemp ? [...listServiceTemp] : [];
    setCurrent(current);
    setDataService(
      data
        ?.sort(compare)
        ?.slice((current - 1) * pageSize, current * pageSize) || 0
    );
  };

  const onChangeMenu = (value) => {
    if (!value) {
      const dataTamp = listService ? [...listService] : [];
      setCurrent(1);
      setDataService(dataTamp?.sort(compare)?.slice(0, 12) || 0);
      setListServiceTemp(listService ? [...listService] : []);
    } else {
      let data = [];
      listService &&
        listService.map((item) => {
          if (item?.category?.split(';')?.find((item1) => item1 === value)) {
            data = [...data, item];
          }
        });
      setCurrent(1);
      setDataService(data?.sort(compare)?.slice(0, 12) || 0);
      setListServiceTemp([...data]);
    }
  };

  const compare = (a, b) => {
    if (a.priority > b.priority) {
      return -1;
    }
    if (a.priority < b.priority) {
      return 1;
    }
    return 0;
  };

  return (
    <div className="service-container">
      {type === 0 ? (
        <Layout style={{ height: 'calc(100vh - 64px)' }}>
          <Sider
            width="240px"
            style={{ background: '#1f1f1f', marginTop: '16px' }}
          >
            <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
              <Menu.Item key="1" onClick={() => onChangeMenu('')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="All-Services"
                      src={AllServices}
                    />
                    {t('All services')}
                  </div>
                  <div>({listService?.length || 0})</div>
                </div>
              </Menu.Item>
              <Menu.Item key="2" onClick={() => onChangeMenu('ai')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="AI-Imag-Analysls"
                      src={AIImageAnalysls}
                    />
                    {t('AI image analysis')}
                  </div>
                  <div>({count1})</div>
                </div>
              </Menu.Item>
              <Menu.Item key="3" onClick={() => onChangeMenu('intergation')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="System-Integration"
                      src={SystemIntegration}
                    />
                    {t('System integration')}
                  </div>
                  <div>({count2})</div>
                </div>
              </Menu.Item>
              <Menu.Item key="4" onClick={() => onChangeMenu('notification')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="System-Alerts"
                      src={SystemAlerts}
                    />
                    {t('System Alerts')}
                  </div>
                  <div>({count3})</div>
                </div>
              </Menu.Item>
              <Menu.Item key="5" onClick={() => onChangeMenu('security')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="Safety-And-Sercurity"
                      src={SafetyAndSercurity}
                    />
                    {t('Safety and security')}
                  </div>
                  <div>({count4})</div>
                </div>
              </Menu.Item>
              <Menu.Item key="6" onClick={() => onChangeMenu('utility')}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <img
                      className="serive-icon"
                      alt="Extensions"
                      src={Group569}
                    />
                    {t('Extensions')}
                  </div>
                  <div>({count5})</div>
                </div>
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout>
            <Content>
              <div className="service-component">
                <div className="main-service-component">
                  {dataService ? (
                    dataService.length > 0 ? (
                      <Row gutter={[16, 16]}>
                        {dataService.map((service, index) => (
                          <Col key={index} xs={24} md={12} lg={6}>
                            <div className="card-service">
                              {service.pricings &&
                                service.pricings.length > 0 && (
                                  <div className="icon-pro-service">
                                    <img alt={service.name} src={ProIcon} />
                                  </div>
                                )}
                              <Card
                                style={{
                                  width: '100%',
                                  border: '2px solid #4F4D4D',
                                  borderRadius: '5px',
                                }}
                              >
                                <div className="body-card-service">
                                  <div className="logo-side">
                                    <img
                                      alt={service.name}
                                      className="image"
                                      src={service.iconUrl}
                                    />
                                  </div>
                                  <div className="info">
                                    <div className="description">
                                      {service.description}
                                    </div>

                                    <div className="btn-detail">
                                      <div
                                        onClick={() => {
                                          setType(1);
                                          handleViewDetail(service);
                                        }}
                                        className="title"
                                      >
                                        {service.name}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <Empty />
                    )
                  ) : (
                    <Spinner />
                  )}
                </div>
              </div>
            </Content>
            <Pagination
              style={{ textAlign: 'end', margin: '0px 15px 20px 0' }}
              showSizeChanger={false}
              onChange={onShowSizeChange}
              current={current}
              pageSize={12}
              total={listServiceTemp?.length}
            />
          </Layout>
        </Layout>
      ) : (
        <ActivationComponent
          setType={setType}
          key={key}
          service={detailService && detailService.service}
        />
      )}
    </div>
  );
};

export default ServicePage;
